export const primaryColor = "red"
export const secondaryColor = "brown"
export const background = "#A52A2A"

export const navbar_color = "#F7F7FF"